import { QuestionVisibilityState } from "@/components/survey/Question";

import {
  getMedBmiThresholds,
  meetsMedBmiAndComorbityCriteria,
} from "../qualification";
import { isGlp1FdaLabelingEnforced } from "../qualification/glp1EligibilityConfig";

import { shouldAskBaselineOutcomes } from "./outcomes";

export const shouldShowGlp1MedicationQuestion = (
  state: QuestionVisibilityState,
): boolean => {
  const {
    partnerInfo,
    retriageEligibility,
    surveyAnswers: {
      diabetesType,
      healthConditions,
      heightWeight: { heightFeetPortion, heightInchesPortion, weight } = {},
    },
  } = state;

  // Initial enrollment
  if (!retriageEligibility) {
    return shouldAskBaselineOutcomes(partnerInfo);
  }

  const { eligibleRetriagePrograms = [] } = retriageEligibility || {};

  if (!eligibleRetriagePrograms.includes("MED")) {
    return false;
  }

  if (
    heightFeetPortion === undefined ||
    heightInchesPortion === undefined ||
    weight === undefined
  ) {
    return false;
  }

  return !meetsMedBmiAndComorbityCriteria(
    diabetesType,
    healthConditions,
    heightFeetPortion,
    heightInchesPortion,
    weight,
    getMedBmiThresholds(partnerInfo),
  );
};

export const shouldShowGlp1WeightQuestion = (
  state: QuestionVisibilityState,
): boolean => {
  const {
    eligibilityInfo: { eligiblePrograms = [] } = {},
    partnerInfo,
    retriageEligibility,
    surveyAnswers: {
      diabetesType,
      healthConditions,
      heightWeight: { heightFeetPortion, heightInchesPortion, weight } = {},
      glp1Medication,
    },
  } = state;

  if (!isGlp1FdaLabelingEnforced(partnerInfo)) {
    // Starting weight only exists to evaluate the FDA/start-BMI/5% exclusion.
    // When that rule is disabled for the partner, don't ask it as a qualifying step.
    return false;
  }

  if (
    !(
      eligiblePrograms.includes("MED") ||
      retriageEligibility?.eligibleRetriagePrograms?.includes("MED")
    )
  ) {
    return false;
  }

  if (
    heightFeetPortion === undefined ||
    heightInchesPortion === undefined ||
    weight === undefined
  ) {
    return false;
  }

  return (
    glp1Medication === "yes" &&
    !meetsMedBmiAndComorbityCriteria(
      diabetesType,
      healthConditions,
      heightFeetPortion,
      heightInchesPortion,
      weight,
      getMedBmiThresholds(partnerInfo),
    )
  );
};
